import {
  Image,
  Text,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerBody,
  DrawerHeader,
  DrawerCloseButton,
  Flex,
  Box,
} from "@chakra-ui/react";
import React, { useEffect } from "react";

export const MountInfoModal = ({ isOpen, onClose }) => {
  return (
    <Drawer placement={"bottom"} onClose={onClose} isOpen={isOpen}>
      <DrawerOverlay />
      <DrawerContent maxH={"85vh"}>
        <Flex
          mx={3}
          my={4}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Text mr={4} fontSize={"18px"} fontWeight={800}>
            About Local Experiences
          </Text>

          <DrawerCloseButton pos={"relative"} top={0} right={0} />
        </Flex>
        <DrawerBody px={0} pt={0} pb={12}>
          <Image
            pb={4}
            objectFit="cover"
            //   h={"95px"}
            //   w={"120px"}
            src={
              "https://images.pexels.com/photos/327269/pexels-photo-327269.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
            }
            alt={"Linkbase: Mount Local Experiences"}
          />
          <Text px={4}>
            Want to explore like a local? To make your stay even more worth it,
            I've put together a list of my favorite local gems. Here you will be
            able to browse and book local experiences that fit your interests.
          </Text>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};
